export default __webpack_public_path__ + "static/media/28.211d27be.jpg";